import { render, staticRenderFns } from "./QLong.vue?vue&type=template&id=54136944&scoped=true"
import script from "./QLong.vue?vue&type=script&lang=js"
export * from "./QLong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54136944",
  null
  
)

export default component.exports